import React from "react";

const About = () => {
  return (
    <div
      name="about"
      id="about"
      className="w-full h-screen bg-[#0a192f] text-gray-300"
    >
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className=" py-16 rounded-md bg-cyan-800 flex flex-col justify-center items-center w-4/6">
          <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8 mb-4">
            <div className="sm:text-right pb-8 pl-4">
              <p className="text-4xl font-bold inline border-b-4 border-cyan-500">
                About
              </p>
            </div>
            <div></div>
          </div>
          <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
            <div className="sm:text-right text-4xl font-bold">
              <p>
                Hi. I'm Vaibhav Saini.
                <br />
                Please feel free to take a look around.
              </p>
            </div>
            <div>
              <p>
                {" "}
                Experienced in both software engineering and machine learning,
                I have taken projects from conception to implementation,
                deploying robust AI & ML models into production and crafting responsive, scalable web products.
                My journey encompasses the realms of data science, where I have pioneered data-driven insights,
                and software development, where I've built applications that seamlessly meld innovation with user experience.
                I am dedicated to continuous learning, keeping a pulse on the latest technologies, and embracing novel approaches to problem-solving.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default About;